import React, {useCallback, useState} from 'react';
import 'react-modal-video/scss/modal-video.scss';
import faqData from "../../data/faqLahalleData";
import Parser from "html-react-parser";
import ContactModal from "../../components/ContactModal";

const CLASS_NAMES = {
    ACTIVE: 'active',
    ACTIVE_BLOCK: 'active-block',
    CURRENT: 'current',
};
function FAQ() {

    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = useCallback((index) => {
        setActiveIndex(prevIndex => prevIndex === index ? null : index);
    }, []);


    return (
            <section className="faqs-section" style={{background: "#F5F9FE"}}>
                <div className="auto-container">
                    {/*<div className="homepage-titre poppins mb-1">Exemples de questions <span>fréquemment posées</span>
                    </div>*/}
                    <h2 className="libre-title raleway">FAQ : <span>réponses aux questions fréquentes</span></h2>

                    <div className="text mt-30 nunito text-center">
                        À La Halle, on sait que le handicap au travail peut soulever pas mal de questions,
                        qu’on soit en situation de handicap, ayant des difficultés de santé chroniques,
                        salarié aidant ou manager d’une personne concernée... cette FAQ rassemble des réponses simples et utiles
                        sur les démarches, les droits, les aménagements… et bien d’autres sujets que vous pouvez
                        rencontrer dans votre quotidien professionnel. Si vous ne trouvez pas de réponse
                        dans cette foire aux questions, n’hésitez pas à prendre rendez-vous avec un expert.
                    </div>

                    <ul className="accordion-box">
                        {faqData.slice(0, 3).map((item, index) => (
                                <li
                                        key={index}
                                        className={`accordion block ${
                                                activeIndex === index ? CLASS_NAMES.ACTIVE_BLOCK : ''
                                        }`}
                                >
                                    <div
                                            className={`nunito acc-btn ${
                                                    activeIndex === index ? CLASS_NAMES.ACTIVE : ''
                                            }`}
                                            onClick={() => handleClick(index)}
                                    >
                                        {item.question}
                                        <span className="icon flaticon-add"></span>
                                    </div>
                                    <div
                                            className={`nunito acc-content ${
                                                    activeIndex === index ? CLASS_NAMES.CURRENT : ''
                                            }`}
                                    >
                                        <div className="content">

                                            <p>{Parser(item.answer)}</p>
                                        </div>
                                    </div>
                                </li>
                        ))}
                    </ul>
                    <div className="text-center page-lahalle">
                        <ContactModal textButton="Voir plus"
                                      showText={false}
                                      small="small"
                                      linkPageContact={false}
                                      iframe={false}
                                      couleur={false}
                                      page="lahalle"
                                      faq={true}
                        />
                    </div>
                </div>
            </section>
    )
}

export default FAQ;
